import React, { FC, useEffect } from "react";
import { Text } from "@/styles/reactnative";
import {
  ModalBody,
  ModalCloseButton,
  ModalContainer,
  ModalHeader,
  ModalOverlay,
} from "./styles";
import { useIsMobile } from '@utils/CalVW.tsx';
import { useDisableScroll } from '@utils/useDisableScroll.tsx';

type ModalProps = {
  visible: boolean;
  onClose: () => void;
  children?: any;
  title?: string;
  bgColor?: string;
  width?: string;
};
const CModal: FC<ModalProps> = ({
  visible,
  onClose,
  children,
  title,
  bgColor,
  width
}) => {
  const isMobile = useIsMobile();

  useDisableScroll(visible);

  const handleTouchMove = (e) => {
    e.stopPropagation();
  };

  useEffect(() => {
    if (visible) {
      // Disable scrolling on the window when the modal is open
      document.body.style.overflow = "hidden";
      // Re-enable scrolling when the modal is closed
      return () => {
        document.body.style.overflow = "visible";
      };
    }
  }, [visible]);



  return (
    <>
      {visible && (
        <ModalOverlay onClick={onClose}>
          <ModalContainer
            style={{ background: bgColor ? bgColor : "#fff", width: isMobile ? "95%" : width ? width : '800px' }}
            onClick={(e) => e.stopPropagation()}
            onTouchMove={handleTouchMove}
          >
            {title ? (
              <ModalHeader>
                <Text
                  size={20}
                  style={{
                    fontWeight: "bold",
                  }}
                >
                  {title ? title : ""}
                </Text>
                <ModalCloseButton onClick={onClose}>x</ModalCloseButton>
              </ModalHeader>
            ) : null}

            <ModalBody>{children}</ModalBody>
          </ModalContainer>
        </ModalOverlay>
      )}
    </>
  );
};

export default React.memo(CModal);
